import React from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ComponentInfo, CardPlan } from '@components';
import { rem } from '@helpers';
import { saveSuccessServiceResponse, useHasIntegratedSolution, usePlans } from '@store';
import { useDispatch } from 'react-redux';
import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const PlanCardsPlaceholder: React.FC = () => {
	const dispatch = useDispatch();
	const hasIntegratedSolution = useHasIntegratedSolution();
	const plans = usePlans();

	useDidMount(() => {
		// clean all documents saved
		dispatch(
			saveSuccessServiceResponse({
				retrieveBankDocumentReference: undefined,
				retrieveBankInsuranceDocumentReference: undefined,
				retrieveBankInsurancePersonalDocumentReference: undefined,
				retrieveSoftwareDocumentReference: undefined,
			})
		);
	});

	return (
		<ComponentInfo name="PlanCardsPlaceholder">
			<Box styles={{ display: 'flex', flexDirection: 'column', margin: rem(32, 0, 0, 0), alignItems: 'center' }}>
				<CardPlan hasIntegratedSolution={hasIntegratedSolution} plans={plans} />
			</Box>
		</ComponentInfo>
	);
};
